export default "__VITE_ASSET__Cqwt5MnI__"